import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Checkbox, Table, Button, Icon } from 'semantic-ui-react';
import { Resizable } from 'react-resizable';
import FacetField from '../../FilterComponents';
import CustomCheckbox from "../../BaseComponents/CustomCheckbox";
import { additionalActionsSelector } from '../../../ducks/gridList';


const Filter = props => {
    const {
        isShowActions,
        indeterminate,
        all,
        checkAllDisabled,
        setSelectedAll,
        columns,
        resizeColumn,
        extWidth,
        additionalActions,
        gridName,
        filters,
        withCheckbox = true
    } = props;



    const handleResize = useCallback((e, { size, index }) => {
        resizeColumn(size, index);
    }, []);

    const getColumnWidth = (columnWidth, columnName, index) => {
        if (columnWidth && columnWidth > 0) {
            return { width: `${columnWidth}px` }
        } else {
            const col = document.getElementsByClassName(`column-facet column-${columnName &&
                columnName.toLowerCase().replace(' ', '-')}-facet`)[0];
            const colAutoWidth = col && col.offsetWidth;
            return { width: `${colAutoWidth > 70 ? colAutoWidth : 70}px` };
        }
    }



    return (
        <Table.Row className="sticky-header">
            {withCheckbox && <Table.HeaderCell className="small-column">
                <CustomCheckbox
                    indeterminate={indeterminate}
                    checked={all}
                    multi
                    disabled={checkAllDisabled}
                    onChange={setSelectedAll}
                />
            </Table.HeaderCell>}
            
            {columns &&
                columns.map((x, i) => (
                    <Resizable
                        key={`resizable_${x.name}`}
                        width={x.width ? x.width : 120}
                        height={0}
                        axis="x"
                        onResize={(e, { size }) => handleResize(e, { size, index: i })}
                    >
                        <Table.HeaderCell
                            key={'th' + x.name}
                            style={getColumnWidth(x.width, x.name, i)}
                            className={`column-facet column-${x.name &&
                                x.name.toLowerCase().replace(' ', '-')}-facet`}
                        >
                            <FacetField
                                key={'facet' + x.name}
                                {...x}
                                index={i}
                                gridName={gridName}
                                setSort={props.setSort}
                                noSort={x.isSortDisabled}
                                type={x.filterType}
                                value={x.filter}
                                setFilter={props.setFilter}
                                filters={filters}
                                noFilter={x.isFilterDisabled}
                                handleResize={handleResize}
                            />
                        </Table.HeaderCell>
                    </Resizable>
                ))}
            
            <Table.HeaderCell style={{ width: extWidth > 0 ? extWidth : 0 }} />
            {isShowActions ? <Table.HeaderCell className="actions-column" /> : null}
        </Table.Row>
    );
};

export default Filter;
